import { z } from "zod";
import { courtTypeSchema } from "./court-type";
import { provinceSchema } from "./province";

export const courtTypeStationSchema = z.object({
	id: z.string().optional(),
	name: z.string(),
	code: z.string(),
	province_code: z.string(),
	court_type_id: z.string(),
	province: provinceSchema.optional(),
	courtType: courtTypeSchema.optional(),
	created_at: z.string().optional(),
	udpated_at: z.string().optional(),
});

export type CourtTypeStation = z.infer<typeof courtTypeStationSchema>;
